import { render, staticRenderFns } from "./DefStandardForm.vue?vue&type=template&id=1785963a&"
import script from "./DefStandardForm.vue?vue&type=script&lang=js&"
export * from "./DefStandardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports